<template>
  <div class="container full-height">
    <div class="row flex-fill">
      <div class="col-md-9 text-start">
        <div class="d-flex flex-row mb-2 mt-4">
          <div class="flex-grow-1">
            <h5 class="bold">Your cart</h5>
          </div>
          <div
            v-if="cartStore.cart.length > 0"
            class="d-flex justify-content-end bold"
          >
            Containing
            {{
              cartStore.cart.length +
              " " +
              (cartStore.cart.length == 1 ? "product" : "products")
            }}
          </div>
        </div>
        <div v-if="!cartStore.hasAnyItems()">Cart is empty.</div>
        <CartViewItem
          v-for="(item, index) in cartStore.cart"
          :key="item.product.itemId + '-' + index"
          :productData="item.product"
          :quantity="item.quantity"
          :discount="item.discount"
          :itemData="item"
          :isCart="true"
        />
      </div>

      <div class="col-md-3 d-flex summary">
        <Summary />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-facing-decorator";
import Summary from "@/components/cart/Summary.vue";
import CartViewItem from "@/components/products/CartViewItem.vue";
import { useCartStore } from "@/store/cartStore";

@Component({
  components: { Summary, CartViewItem },
})
class CartView extends Vue {
  cartStore = useCartStore();
}
export default CartView;
</script>
